/**
 * 正向提示词输入组件
 */

import type { ReactElement, ChangeEvent } from 'react'
import { cn } from '@/lib/utils'
import type { FormFieldProps } from './types'

/**
 * 正向提示词输入组件
 * @param props 组件属性
 * @returns 组件元素
 */
export function PositivePromptField({
  component,
  value,
  onChange,
  error,
  disabled = false,
  enableMultiPrompt = false,
}: FormFieldProps): ReactElement {
  const textValue = typeof value === 'string' ? value : ''
  const lineCount = textValue.split('\n').filter((line) => line.trim() !== '').length

  /**
   * 处理输入变化
   * @param event 输入事件
   */
  function handleChange(event: ChangeEvent<HTMLTextAreaElement>): void {
    onChange(event.target.value)
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">
        {component.title}
        {component.is_required && (
          <span className="ml-1 text-destructive">*</span>
        )}
      </label>
      <textarea
        value={textValue}
        onChange={handleChange}
        disabled={disabled}
        rows={4}
        placeholder="描述你想生成的画面，越具体越容易获得稳定结果..."
        className={cn(
          'w-full resize-none rounded-xl border bg-background p-3 text-sm outline-none transition-all',
          'focus:border-primary focus:ring-1 focus:ring-primary',
          'placeholder:text-muted-foreground/60',
          error !== undefined && 'border-destructive focus:border-destructive focus:ring-destructive',
          disabled && 'cursor-not-allowed opacity-50'
        )}
      />
      {enableMultiPrompt && (
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>每行一个提示词，将与每张图片组合生成</span>
          {lineCount > 0 && <span>{lineCount} 个提示词</span>}
        </div>
      )}
      {error !== undefined && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  )
}
